import { useEffect, useMemo } from "react";
import {
  DOC_STYLE,
  SEAL_IMAGE,
  SAMPLE_VALUES,
  SAMPLE_ROOM_TABLE_HTML,
} from "./constants";
import banner from "./vow-header-banner.jpg";

const escapeHtml = (s) =>
  String(s).replace(
    /[&<>"]/g,
    (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c],
  );

function fillSamples(body) {
  return body
    .replace(/\{\{room_details\}\}/g, SAMPLE_ROOM_TABLE_HTML)
    .replace(/\{\{seal\}\}/g, `<img src="${SEAL_IMAGE}" alt="" style="max-height:30mm">`)
    .replace(/\{\{([A-Za-z0-9_]+)\}\}/g, (m, k) =>
      k in SAMPLE_VALUES ? escapeHtml(SAMPLE_VALUES[k]) : m,
    );
}

const SCREEN_CSS = `
html { background: #d9dce1; }
.page { margin: 14px auto; box-shadow: 0 1px 6px rgba(0,0,0,.25); }
`;

export default function PreviewModal({ body, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const srcDoc = useMemo(() => {
    const abs = new URL(banner, window.location.href).href;
    const style = DOC_STYLE.replace(/\{\{logo\}\}/g, abs);
    return (
      `<!doctype html><html><head><meta charset="utf-8">` +
      `<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet">` +
      `<style>${style}${SCREEN_CSS}</style></head><body>${fillSamples(body)}</body></html>`
    );
  }, [body]);

  return (
    <div
      className="de-preview"
      role="dialog"
      aria-modal="true"
      aria-label="Preview"
    >
      <div className="de-preview-bar">
        <strong>Preview</strong>
        <span>Sample values filled in. This is not the final PDF.</span>
        <button type="button" onClick={onClose}>
          Exit preview (Esc)
        </button>
      </div>
      <iframe title="Document preview" sandbox="" srcDoc={srcDoc} />
    </div>
  );
}
